import React, { useEffect, useRef, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ContextBoard } from "../../context/ContextBoard";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import $ from "jquery";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

function ChallanNotGenerated10() {
  const tableRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = sessionStorage.getItem("secondaryaccountstoken");
  const { selectedDistrict } = useContext(ContextBoard);

  useEffect(() => {
    if (!selectedDistrict) {
      navigate("/secondary-accounts-dashboard-class-x");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL2}/FOChallanNotGenerated_CL10`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              districtcode: selectedDistrict,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        setTableData(data.data.foChallanNotGenerated_list);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching table data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (tableData.length > 0) {
      const table = $(tableRef.current).DataTable({
        paging: true,
        info: false,
        destroy: true,
        columnDefs: [{ orderable: false, targets: 0 }],
      });
      return () => table.destroy();
    }
  }, [tableData]);

  const generateExcel = async () => {
    if (!tableData.length) {
      Swal.fire("No Data", "No student data available for export.", "warning");
      return;
    }

    try {
      setLoading(true);
      const now = new Date();
      const formattedDateTime = `${now
        .getDate()
        .toString()
        .padStart(2, "0")}-${(now.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${now.getFullYear()} ${now
        .getHours()
        .toString()
        .padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}:${now
        .getSeconds()
        .toString()
        .padStart(2, "0")}`;

      const ws = XLSX.utils.aoa_to_sheet([
        ["Challan Not Generated List"],
        ["Print Date & Time:", formattedDateTime],
        [],
        [],
        [
          "Sl. No",
          "District",
          "School Code",
          "School Name",
          "Student ID",
          "Father Name",
          "Mother Name",
          "Gender",
          "Category",
          "Checklist Status",
        ],
      ]);

      const rows = tableData.map((student, index) => [
        index + 1,
        student.district || "",
        student.schooL_CODE || "",
        student.schooL_NAME || "",
        student.candidatE_ID || "",
        student.fatheR_NAME || "",
        student.motheR_NAME || "",
        student.gender || "",
        student.studenT_EXAM_SUB_CATEGORY || "",
        student.checklisT_STATUS || "",
      ]);

      XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

      ws["!cols"] = [
        { wch: 8 },
        { wch: 20 },
        { wch: 15 },
        { wch: 30 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 10 },
        { wch: 15 },
        { wch: 15 },
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Challan Not Generated");

      const fileName = `Challan_Not_Generated_List.xlsx`;
      XLSX.writeFile(wb, fileName);

      setLoading(false);

      Swal.fire({
        title: "Success",
        text: "Excel file has been generated successfully!",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error generating Excel:", error);
      setLoading(false);
      Swal.fire(
        "Error",
        "An error occurred while generating the checklist.",
        "error"
      );
    }
  };

  return (
    <>
      <div className="container-scroller">
        <Navbar />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-user"></i>&nbsp; Challan Not Generated
                      List
                    </h1>
                    <ol className="breadcrumb">
                      <li>
                        <a
                          href="accounts-dashboard"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/secondary-accounts-dashboard-class-x");
                          }}
                        >
                          Home&nbsp;
                        </a>
                      </li>
                      <li className="active"> Challan Not Generated List</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div className="row" style={{ padding: "0px" }}>
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="row mb-2">
                        {/* {tableData.length > 0 && (
                                                    <div className="col-md-12 text-right">
                                                        <button
                                                            onClick={generateExcel}
                                                            className="btn btn-success btn-sm"
                                                        >
                                                            <i className="fa fa-file-excel"></i> Export to Excel
                                                        </button>
                                                    </div>
                                                )} */}
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="table-responsive">
                            <table
                              className="table table-hover table-bordered mb-0"
                              ref={tableRef}
                            >
                              <thead>
                                <tr className="table-info">
                                  <th>Sl. No</th>
                                  <th>District</th>
                                  <th>School Code</th>
                                  <th>School Name</th>
                                  <th>Student ID</th>
                                  <th>Father Name</th>
                                  <th>Mother Name</th>
                                  <th>Gender</th>
                                  <th>Category</th>
                                  <th>Checklist Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {tableData.length > 0 ? (
                                  tableData.map((item, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{item.district}</td>
                                      <td>{item.schooL_CODE}</td>
                                      <td>{item.schooL_NAME}</td>
                                      <td>{item.candidatE_ID}</td>
                                      <td>{item.fatheR_NAME}</td>
                                      <td>{item.motheR_NAME}</td>
                                      <td>{item.gender}</td>
                                      <td>{item.studenT_EXAM_SUB_CATEGORY}</td>
                                      <td>
                                        {item.checklisT_STATUS === "PRINTED" ? (
                                          <span className="badge bg-success border border-success">
                                            {item.checklisT_STATUS}
                                          </span>
                                        ) : (
                                          <span className="badge bg-warning border border-warning">
                                            {item.checklisT_STATUS}
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="10"
                                      className="text-center text-muted"
                                    >
                                      No data available
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default ChallanNotGenerated10;
